import angular from 'angular';

import { BannerComponent } from './banner/banner.component';
import { FooterComponent } from './footer/footer.component';
import { ForgotPasswordModalComponent } from './forgotPwModal/forgotPasswordModal.component';
import { PasswordFormComponent } from './passwordForm/passwordForm.component';
import { AppStoreLinksComponent } from "./appStoreLinks/appStoreLinks.component";
import { AppFunctionsComponent } from "./appFunctions/appFunctions.component";
import { HipaaAuthorizationComponent } from './hipaaAuthorization/hipaaAuthorization.component';

export const CommonModule = angular
    .module('mmsApp.common', [
    ])
    .component(BannerComponent.name, BannerComponent.component)
    .component(FooterComponent.name, FooterComponent.component)
    .component(ForgotPasswordModalComponent.name, ForgotPasswordModalComponent.component)
    .component(PasswordFormComponent.name, PasswordFormComponent.component)
    .component(AppStoreLinksComponent.name, AppStoreLinksComponent.component)
    .component(AppFunctionsComponent.name, AppFunctionsComponent.component)
    .component(HipaaAuthorizationComponent.name, HipaaAuthorizationComponent.component)
    .name;



// WEBPACK FOOTER //
// ./src/app/common/app.common.module.js